"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Avatar = _interopRequireDefault(require("../Avatar/Avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ModalHeaderAvatar = function ModalHeaderAvatar(_ref) {
  var url = _ref.url,
      Component = _ref.Component,
      props = _objectWithoutPropertiesLoose(_ref, ["url", "Component"]);

  return (0, _themeUi.jsx)(Component, _extends({}, props, {
    src: url,
    size: 7,
    sx: {
      mx: 3,
      my: 2,
      ml: [-2, -3],
      flexShrink: 0,
      borderColor: 'neutral.0',
      borderRadius: '50%',
      borderWidth: 'regular',
      borderStyle: 'solid'
    }
  }));
};

ModalHeaderAvatar.propTypes = {
  Component: _propTypes["default"].func,
  url: _propTypes["default"].string
};
ModalHeaderAvatar.defaultProps = {
  Component: _Avatar["default"],
  url: null
};
var _default = ModalHeaderAvatar;
exports["default"] = _default;